
import { Component, ComponentFactoryResolver, EventEmitter, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { Route, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import * as loginActions from '../../source/appstates/loginstates/loginActions'
import { GamesService } from '../../source/services/games/games.service';
import { Store } from '@ngrx/store';
import * as appState from '../../source/appstates/appState'
import * as cashierActions from '../../source/appstates/cashierstates/cashierActions'
import { SlotsService } from '../../source/services/slotsservice/slots.service';
import { Subscription } from 'rxjs';
import { UpdatePorfileComponent } from '../player/update-porfile/update-porfile.component';
import { LoginState } from '../../source/appstates/loginstates/loginState';

@Component({
  selector: 'app-myaccount',
  standalone: true,
  imports: [CommonModule, MatIconModule, TranslateModule, FormsModule],
  templateUrl: './myaccount.component.html',
  styleUrls: ['./myaccount.component.scss']
})
export class MyaccountComponent {
  @Output() close = new EventEmitter<void>();

  user = {
    name: sessionStorage.getItem('profile') || '',
    // id: 'dev9100',
    // vipPoints: 0,
    mainWallet: sessionStorage.getItem('cashuser') || null,
    bonusWallet: sessionStorage.getItem('bounsuser')
  };

  funds = [
    { label: 'DEPOSIT', route: "deposit", iconimg: "../../../assets/siteImg/profiledrop_icon/icon-deposit.png" },
    { label: 'CASHOUT', route: "cashout", iconimg: "../../../assets/siteImg/profiledrop_icon/icon-withdrawal.png" },
    // { icon: 'account_balance_wallet', label: 'Bonus Wallet' },
    // { icon: 'casino', label: 'Free Spin' }
  ];

  promotions = [
    { label: 'Promotions', route: "/promotions", iconimg: "../../../assets/sitelogos/Promotions.svg" },
    // { icon: 'group_add', label: 'Refer Bonus', badge: null , route : "",iconimg:""},
    // { icon: 'emoji_events', label: 'Winner Board', badge: null , route : "",iconimg:""},
    // { icon: 'local_fire_department', label: 'Daily Streak Challenge', badge: 1, route : "",iconimg:"" }
  ];

  history = [
    { label: 'GAME_HISTORY', route: "casinogamehistory", iconimg: "../../../assets/siteImg/profiledrop_icon/icon-records.png" },
    // { icon: 'sync_alt', label: 'Turnover' },
    { label: 'TRANSACTION_HISTORY', route: "transactionhistory", iconimg: "../../../assets/siteImg/profiledrop_icon/icon-daily-login.png" }
  ];

  profile = [
    { icon: 'manage_accounts', label: 'Personal_Info', badge: null, route: "profile", iconimg: "../../../assets/siteImg/profiledrop_icon/icon-profile.png" },
    { icon: 'lock', label: 'UPDATE_PASSWORD', badge: null, route: "", iconimg: "https://img.d4040p.com/dp/h5/assets/images/icon-set/theme-icon/icon-changepassword.png?v=1777968960008" },
    // { icon: 'inbox', label: 'Inbox', badge: 13 }
  ];

  contacts = [
    { label: 'Email', Link: "mailto:support@gambaji.com", iconimg: "https://img.d4040p.com/dp/h5/assets/images/icon-set/theme-icon/icon-email.png?v=1777968960008" },
    { label: 'Whatsapp', Link: "https://wa.me/message/6WPI5NGU5VDCJ1", iconimg: "../../../assets/siteImg/profiledrop_icon/whatsapp.svg" },
    { label: 'Telegram', Link: "http://t.me/Gambajiofficial", iconimg: "https://img.d4040p.com/dp/h5/assets/images/icon-set/theme-icon/icon-telegram.png?v=1777968960008" },
    { label: 'instagram', Link: "https://www.instagram.com/gembajiofficial?igsh=MWp5cnk0Y3ZscHFiOQ==", iconimg: "../../../assets/siteImg/profiledrop_icon/insta.svg" },
    // { icon: 'chat_bubble', label: 'Live Chat' ,route : "",iconimg:"" }
  ];
  Requiredbonus: any = sessionStorage.getItem('bonusWager')
  lockBonus: any = sessionStorage.getItem('lockBonus')
  @ViewChild('alertHost', { read: ViewContainerRef }) alertHost!: ViewContainerRef;
  private closeSub!: Subscription;
  playerLoggedIn: boolean = false;
  private storeSub!: Subscription;
  constructor(private router: Router, private translate: TranslateService,
    private slotsService: SlotsService, private componentFactoryResolver: ComponentFactoryResolver,
    private gameService: GamesService, private store: Store<appState.AppState>,) { }
  ngOnInit() {


    this.storeSub = this.store.select("loginState").subscribe(
      (loginState: LoginState) => {
        if (loginState.playerLoggedIn) {
          if (loginState.playerLoggedIn.loggedIn) {
            this.playerLoggedIn = loginState.playerLoggedIn.loggedIn;
          } else {
            this.playerLoggedIn = false;
            this.router.navigate(['/home'])
          }
        }
      });

  }

  onClose() {
    this.close.emit();
    this.router.navigate([], {
      queryParams: { modal: null },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }
  openmodal(item: any) {
    if (item.label != "UPDATE_PASSWORD") {
      this.router.navigate([], {
        queryParams: { modal: item.route }, // OR outlet if using that
        queryParamsHandling: 'merge'
      });
    } else if (item.label == "UPDATE_PASSWORD") {
      this.showUpdateProfile('UPDATEPASSWORD')
    }
  }
  openwindow(url: any) {
    window.open(url, '_blank');
  }
  routingurl(url: any) {
    this.router.navigate([url])
  }
  onClickLogout() {
    this.router.navigate(['/']);
    this.store.dispatch(new loginActions.ResetState());
    this.store.dispatch(new cashierActions.ResetState());
    this.store.dispatch(new loginActions.LogoutStart());
    localStorage.removeItem('affcheckid')
    localStorage.removeItem('affCid')
    sessionStorage.clear();
    this.gameService.providerListSubject.next([])
    setTimeout(() => {
      window.location.reload();
    }, 800);
    this.closeGameSession()
  }

  closeGameSession() {
    this.slotsService.endsession().subscribe(data => { })
    let gameSession = sessionStorage.getItem("closeGameSession")
    let body = {
      "gameSession": gameSession
    }

    if (gameSession) {
      this.slotsService.closeGameSession(body).subscribe((res: any) => {
        console.log(res.success)
        if (res.success) {
          sessionStorage.removeItem("closeGameSession")
        }

      })
    }
  }
  promotionsLink() {
    this.router.navigate(['/promotions'])
  }
  showUpdateProfile(value: string) {
    console.log(value)

    if (this.alertHost) {
      const alertCmpFactory = this.componentFactoryResolver.resolveComponentFactory(UpdatePorfileComponent);
      const hostViewContainerRef = this.alertHost;
      hostViewContainerRef.clear();

      const componentRef = hostViewContainerRef.createComponent(alertCmpFactory);
      componentRef.instance.fromProfileState = value;
      if (this.closeSub) {
        this.closeSub.unsubscribe();
      }

      this.closeSub = componentRef.instance.close.subscribe(() => {
        hostViewContainerRef.clear();
      });
    }
  }

}

